import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { exportRowsToCsv, exportRowsToExcel } from '../../../../../helpers/export-helper';

export const SettingsUsersListHeaderActions = () => {
    const navigate = useNavigate();
    const { visibleUsers } = useSelector((state) => state.ui);
    const [isExportOpen, setIsExportOpen] = useState(false);

    const exportRows = Array.isArray(visibleUsers) ? visibleUsers : [];
    const exportColumns = [
        { key: 'name', header: 'Nombre' },
        { key: 'firstName', header: 'Nombre (simple)' },
        { key: 'lastName', header: 'Apellido' },
        { key: 'email', header: 'Email' },
        { key: 'role', header: 'Rol' },
        { key: 'status', header: 'Estatus' },
        { key: 'createdDate', header: 'Alta' },
    ];

    const getNormalizedRows = () => {
        return exportRows.map((user) => ({
            name: user.name || '',
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            email: user.email || '',
            role: user.role || '',
            status: user.active ? 'Activo' : 'Inactivo',
            createdDate: user.createdDate ? new Date(user.createdDate).toLocaleDateString('es-MX') : '',
        }));
    };

    const handleDownloadCsv = () => {
        const rows = getNormalizedRows();
        exportRowsToCsv({
            rows,
            columns: exportColumns,
            baseFileName: 'usuarios_visibles',
        });
        setIsExportOpen(false);
    };

    const handleDownloadExcel = () => {
        const rows = getNormalizedRows();
        exportRowsToExcel({
            rows,
            columns: exportColumns,
            baseFileName: 'usuarios_visibles',
            sheetName: 'Usuarios',
        });
        setIsExportOpen(false);
    };

    const handleDocumentClick = (event) => {
        const exportDropdown = event.target.closest('.dropdown');
        if (!exportDropdown) {
            setIsExportOpen(false);
        }
    };

    const handleExportClick = () => {
        setIsExportOpen(!isExportOpen);
    };

    React.useEffect(() => {
        document.addEventListener('click', handleDocumentClick);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);

    return (
        <div className="page-header-right ms-auto">
            <div className="page-header-right-items">
                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                    <div className="dropdown">
                        <button type="button" className="btn btn-icon btn-light-brand" data-bs-toggle="dropdown" data-bs-offset="0, 10" data-bs-auto-close="outside" aria-expanded="false" onClick={handleExportClick}>
                            <i className="feather-paperclip"></i>
                        </button>
                        <div className={`dropdown-menu dropdown-menu-end ${isExportOpen ? 'show' : ''}`}>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadCsv} disabled={exportRows.length === 0}>
                                <i className="feather-file"></i>
                                <span>CSV</span>
                            </button>
                            <button type="button" className="dropdown-item d-flex align-items-center gap-2" onClick={handleDownloadExcel} disabled={exportRows.length === 0}>
                                <i className="feather-grid"></i>
                                <span>Excel</span>
                            </button>
                        </div>
                    </div>

                    <button type="button" className="btn btn-primary" onClick={() => navigate('/settings/users/create')}>
                        <i className="feather-plus me-2"></i>
                        <span>Nuevo</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
